export const STEPS = {
  CHECK_AVAILABILITY: 'CHECK_AVAILABILITY',
  AVAILABLE: 'AVAILABLE',
  NOT_AVAILABLE: 'NOT_AVAILABLE',
  ERROR: 'ERROR',
  DATA_ISSUE: 'DATA_ISSUE',
  LOADING: 'LOADING',
};

export const defaultValuesHeat = {
  fernwaermeCase: '',
  heat: {},
  lastRequestParams: { olavGaa: '' },
};

export const getAddress = storage => {
  const { plzOrt, strasse, gebadr1, tuerNr } = storage || {};
  return `${plzOrt}, ${strasse} ${gebadr1}${tuerNr ? `/${tuerNr}` : ''}`;
};
